// planesAPI.js
import { ENV } from "../Utils"; // Ajusta la ruta según tu proyecto

export class PlanesAPI {
  baseApi = ENV.BASE_API;


  async getPlans(accessToken, params) {
    //console.log("ENV.API_ROUTES.PLANS", ENV.API_ROUTES.PLANS);
    try {
      const pageFilter = `page=${params?.page || 1}`;
      const limitFilter = `limit=${params?.limit || 10}`;
      const url = `${this.baseApi}/${ENV.API_ROUTES.PLANS}?${pageFilter}&${limitFilter}`;
      //console.log("url" , url);
      const paramsFetch = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
  
      const response = await fetch(url, paramsFetch);
      const result = await response.json();
  
      if (response.status !== 200) throw result;
  
      return result; 
    } catch (error) {
      throw error;
    }
  }

  /**
   * Obtener un plan por su ID.
   * @param {string} id - ID del plan.
   */
  async getPlanById(accessToken, id) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.PLANS}/${id}`;
  
      const paramsFetch = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
  
      const response = await fetch(url, paramsFetch);
      const result = await response.json();
  
      if (response.status !== 200) throw result;
  
      return result;
    } catch (error) {
      throw error;
    }
  }


  async createPlan(accessToken, idPermission, data) {
    try {
      // Si hay archivo para miniature (por ejemplo en data.file), lo movemos a data.miniature
      if (data.file) {
        data.miniature = data.file;
        delete data.file;
      }

      // FormData para enviar datos + posible archivo
      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        formData.append(key, data[key]);
      });

      const url = `${this.baseApi}/${ENV.API_ROUTES.PLANS}/${idPermission}`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`, // envío del token
        },
        body: formData,
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 201) throw result;

      return result; // { code, message, plan }
    } catch (error) {
      throw error;
    }
  }


  async updatePlan(accessToken, idPermission, planId, data) {
    try {
      // Manejo del archivo (miniature) si se envía en data.file
      if (data.file) {
        data.miniature = data.file;
        delete data.file;
      }

      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        formData.append(key, data[key]);
      });

      const url = `${this.baseApi}/${ENV.API_ROUTES.PLANS}/${idPermission}/${planId}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result; // { code, message, plan }
    } catch (error) {
      throw error;
    }
  }

  async deletePlan(accessToken, idPermission, planId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.PLANS}/${idPermission}/${planId}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result; // { code, message, ... }
    } catch (error) {
      throw error;
    }
  }
   /**
   * Agrega (o incrementa) activaciones de planes para un usuario partner.
   * @param {string} accessToken - El token de acceso.
   * @param {string} adminId - ID del usuario admin que tiene permisos.
   * @param {string} partnerId - ID del usuario partner al que se le actualizan las activaciones.
   * @param {Object} data - Objeto que debe contener activations: [{ plan: <planId>, quantity: <number> }, ...].
   * @returns {Object} Resultado de la operación.
   */
   async addActivations(accessToken, adminId, partnerId, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.PLAN_ACTIVATIONS}/${adminId}/${partnerId}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Resta activaciones de planes para un usuario partner.
   * @param {string} accessToken - El token de acceso.
   * @param {string} adminId - ID del usuario admin que tiene permisos.
   * @param {string} partnerId - ID del usuario partner al que se le actualizan las activaciones.
   * @param {Object} data - Objeto que debe contener activations: [{ plan: <planId>, quantity: <number> }, ...].
   * @returns {Object} Resultado de la operación.
   */
  async removeActivations(accessToken, adminId, partnerId, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.PLAN_ACTIVATIONS}/${adminId}/${partnerId}`;
      const params = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}
